/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'TablaEtiquetaItems.EtiquetaItems': 'Etiqueta Items ',
    'TablaEtiquetaItems.DescripcionItem': 'Producto ',
    'TablaEtiquetaItems.CodigoEmpresaItem': 'Código Empresa',
    'TablaEtiquetaItems.Unidad': 'Unidad',
    'TablaEtiquetaItems.Clasificacion': 'Clasificacion',
};
